import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const KemLogo: React.FC<IconProps> = ({
  color = '#fff',
  size = 28,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 97 96"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <g clipPath="url(#clip0_29740_48869)" fill={color}>
      <path d="M35.084 83.725l11 11c1.394 1.393 3.668 1.409 5.062.015l44-44 .063-.064a3.59 3.59 0 000-5.077L51.023 1.413a3.59 3.59 0 00-5.077 0l-.064.064L41.13 6.23c-1.394 1.393-1.379 3.668.015 5.061L76.922 47.07l.952.952-.946.946-27.397 27.398-.947.946-.952-.952-2.591-2.591c-1.394-1.394-3.668-1.409-5.062-.015l-4.91 4.91c-1.394 1.394-1.379 3.668.015 5.062z" />
      <path d="M1.898 50.539l22.255 22.255c1.394 1.393 3.668 1.409 5.062.015l19.879-19.88.946-.946.952.952 2.673 2.673.094.094a3.457 3.457 0 004.889 0l4.91-4.91c1.394-1.394 1.379-3.668-.015-5.062L52.462 34.649c-1.394-1.394-3.669-1.41-5.062-.016L27.562 54.471l-.946.946-.952-.952-5.448-5.447-.951-.952.946-.946 19.838-19.838.143-.143a3.366 3.366 0 000-4.76l-5.067-5.067c-1.394-1.394-3.668-1.409-5.062-.015l-28.18 28.18c-1.394 1.394-1.378 3.668.015 5.062z" />
    </g>
    <defs>
      <clipPath id="clip0_29740_48869">
        <path fill={color} transform="translate(.5)" d="M0 0H96V96H0z" />
      </clipPath>
    </defs>
  </svg>
)
